<template>
  <div>
    <v-layout
      v-if="componentLoading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      column
      wrap
    >
      <v-container
        grid-list-md
        fluid
        class="pa-2"
      >
        <branding />
        <location-settings class="my-2" />
      </v-container>
    </v-layout>
  </div>
</template>
<script>
import Branding from './Branding';
import LocationSettings from './LocationSettings';

export default {
  name: 'Account',
  components: {
    branding: Branding,
    'location-settings': LocationSettings
  },
  data() {
    return {
      componentLoading: true
    };
  },
  mounted() {
    this.componentLoading = false;
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Account' });
  }
};
</script>

